export default __webpack_public_path__ + "static/media/FlextureDesignsImg.36326155.png";